import { useState, useEffect, useContext, useRef } from "react";
import { Link, Navigate, useLocation, useNavigate } from "react-router-dom";

import PulseLoader from "react-spinners/PulseLoader";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";

import { Card, Grid, Badge } from "@mui/material";

import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Tooltip from "@mui/material/Tooltip";

import CategoryContext from "context/category-context";
import { AccountContext } from "context/account";
import SharedContentContext from "context/shared-content";

import toast from "react-hot-toast";
import moment from "moment";
import Error404 from "pages/error/404";
import ClearIcon from "@mui/icons-material/Clear";
import DoneIcon from "@mui/icons-material/Done";
import EditIcon from "@mui/icons-material/Edit";
import IconButton from "@mui/material/IconButton";

import NumberFormat from "react-number-format";
import DataTable from "examples/Tables/DataTable";
import DraggableDialog from "components/UpStyled/DraggableDialog";

import DeleteForeverRoundedIcon from "@mui/icons-material/DeleteForeverRounded";
import AddIcon from "@mui/icons-material/Add";
import SearchIcon from "@mui/icons-material/Search";
import AddPhotoAlternateIcon from "@mui/icons-material/AddPhotoAlternate";

import SuiBox from "components/SuiBox";
import SuiTypography from "components/SuiTypography";
import SuiBadge from "components/SuiBadge";
import SuiSelect from "components/SuiSelect";
import SuiInput from "components/SuiInput";
import SuiBadgeDot from "components/SuiBadgeDot";
import SuiAvatar from "components/SuiAvatar";
import SuiButton from "components/SuiButton";

import ChatRoom from "pages/messages/chatroom";
import ContactAvatar from "components/UpStyled/ContactAvatar";

import { Carousel } from "antd";
import api from "services/api";

import {
  handleUploadFiles,
  getStyleImages,
  getTechPackImages,
  canResizeImageUrl,
  getFileImage,
} from "utils/imageHelper";
import { stylesSortOptions } from "utils/data";
import { compare, checkPermission } from "utils/helper";
import { projectSortOptions, projectStatusOptions } from "utils/data";

//import StyleImageGallery from "./StyleImageGallery";
import Prompt from "components/UpStyled/Prompt";
import EmptyStyleRecord from "pages/de/styles/components/EmptyStyleRecord";
import ImageCardWrapper from "components/UpStyled/ImageCardWrapper";
import ReadMore from "components/UpStyled/ReadMore";
import Actionables from "components/UpStyled/Actionables";

import ProjectDetailSimpleModal from "pages/de/collection/detail/components/ProjectDetailSimpleModal";
import FullCreateStyleModal from "pages/de/project/create-project/components/FullCreateStyleModal";
import ImportStyleModal2 from "pages/de/project/create-project/components/ImportStyleModal2";
import CreateCollectionModal from "pages/de/collection/components/CreateCollectionModal";
import CollectionDetailHeader from "pages/de/collection/detail/components/CollectionDetailHeader";
import NewSharedBar from "pages/de/share-page/newsharebar";
import { useForm, Controller } from "react-hook-form";
import { ErrorMessage } from "@hookform/error-message";
import { DatePicker } from "antd";
import { seasonOptions } from "utils/data";

const smartdate = require("smartdate");

const STYLE_DESC_MAX_LENGTH = 2000;
const MAX_STYLE_NUMBER_COUNT = 12;
const MAX_TAG_LENGTH = 40;

const CollectionDetail = ({
  detail,
  editable = false,
  handleRefresh,
  pageLoading = false,
  sharedView = false,
}) => {
  const [moodboards, setMoodboards] = useState([]);

  const [uploading, setUploading] = useState(false);
  const [editNameVisible, setEditNameVisible] = useState(false);
  const [importStyleVisible, setImportStyleVisible] = useState(false);
  const [createStyleVisible, setCreateStyleVisible] = useState(false);
  const [editCollectionVisible, setEditCollectionVisible] = useState(false);

  const [deleteVisible, setDeleteVisible] = useState(false);
  const [selectedMoodboard, setSelectedMoodboard] = useState({});
  const [deleteStyleVisible, setDeleteStyleVisible] = useState(false);
  const [selectedStyle, setSelectedStyle] = useState({});
  const [projectMaps, setProjectMaps] = useState({});
  const [filteredStyles, setFilteredStyles] = useState([]);
  const [orderOpt, setOrderOpt] = useState(stylesSortOptions[0]);
  const [searchStr, setSearchStr] = useState("");
  const [chatVisible, setChatVisible] = useState(false);
  const [selectedItem, setSelectedItem] = useState({});
  const [projectDetailVisible, setProjectDetailVisible] = useState(false);
  const [projectDetail, setProjectDetail] = useState({});
  const [inputWidth, setInputWidth] = useState(20);
  const [collectionDesc, setCollectionDesc] = useState("");
  const [collectionTags, setCollectionTags] = useState([]);
  const [inputTag, setInputTag] = useState("");

  const [chats, setChats] = useState(new Map());

  const seasonLabel = detail?.metadata?.season?.label || "";
  const yearLabel = detail?.metadata?.year ? moment(detail?.metadata?.year).format("YYYY") : "";

  const {
    register,
    handleSubmit,
    trigger,
    setValue,
    reset,
    control,
    formState: { errors },
  } = useForm();

  smartdate.init();

  const navigate = useNavigate();
  const account = useContext(AccountContext);
  const { permissionMap, retrieveContentPermission } = useContext(SharedContentContext);

  const isOwner = detail?.store_id == account.id || detail?.owner_id == account.id;

  let products = detail?.products || [];

  const shareSessionRef = useRef({});
  const collectionNameInputRef = useRef(null);

  const {
    tree,
    actions: { findNodeByID, findParents },
  } = useContext(CategoryContext);

  useEffect(() => {
    if (sharedView) {
      retrieveContentPermission();
    }
  }, [detail.id]);

  useEffect(() => {
    products = products.sort((a, b) => compare(a, b, orderOpt?.value));
    if (!sharedView) {
      retrieveChats();
    }
    if (canWrite) {
      ListProjectByStyle();
    }

    setFilteredStyles(products);
  }, [detail]);

  useEffect(() => {
    const meta = detail?.metadata ? detail.metadata : {};
    reset({
      collection_name: detail?.title,
      year: meta?.year ? moment(meta?.year) : null,
      season: meta?.season,
      description: detail?.description,
      brand: meta?.brand,
    });
    setCollectionDesc(detail?.description);
  }, [detail]);

  const handleChangeCollectionName = async () => {
    let value = collectionNameInputRef?.current?.value || "";
    value = value.trim();

    if (value == detail?.title || !value) {
      setEditNameVisible(false);
      return;
    }
    try {
      await api.collections.update(detail.id, { title: value });
      handleRefresh();
      toast.success("Collection name has been successfully updated!");
    } catch (err) {
      console.log(err);
      toast.error("Collection name could not be updated!");
    }
    setEditNameVisible(false);
  };

  const handleShowEditCollectionName = () => {
    setEditNameVisible(true);
    setInputWidth(detail?.title?.length);
  };

  const formatProjectStatus = (type) => {
    const option = projectStatusOptions.find((x) => x.value == type);
    if (option) {
      if (option.value == "init") {
        return <SuiBadgeDot color="warning" badgeContent={option.label} />;
      } else if (option.value == "requested") {
        return <SuiBadgeDot size="xs" color="info" badgeContent={option.label} />;
      } else if (option.value == "active") {
        return <SuiBadgeDot size="xs" color="success" badgeContent={option.label} />;
      } else if (option.value == "canceled") {
        return <SuiBadgeDot color="error" badgeContent={option.label} />;
      } else if (option.value == "completed") {
        return <SuiBadgeDot color="dark" badgeContent={option.label} />;
      } else {
        return <SuiBadgeDot color="secondary" badgeContent={option.label} />;
      }
    } else {
      return type;
    }
  };

  const handleProjectCellClick = (p) => {
    if (sharedView) {
      setProjectDetail(p);
      setProjectDetailVisible(true);
    } else {
      navigate(`/produce/all-projects?id=${p.id}`);
    }
  };

  const ProjectCell = ({ projects }) => (
    <SuiBox
      display="flex"
      alignItems="center"
      justifyContent="center"
      sx={{ height: "100%", width: "100%" }}
    >
      <SuiBox>
        {projects.map((p) => (
          <SuiBox>
            <SuiBox
              display="flex"
              alignItems="center"
              justifyContent="space-between"
              width="100%"
              pb={0.5}
            >
              <SuiBox
                onClick={() => {
                  handleProjectCellClick(p);
                }}
                sx={{ cursor: "pointer" }}
              >
                <Tooltip title={p.name}>
                  <SuiTypography
                    variant="h6"
                    fontWeight="medium"
                    textTransform="capitalize"
                    lineHeight="1.2"
                    sx={{
                      maxWidth: 150,
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      display: "-webkit-box",
                      WebkitLineClamp: "1",
                      WebkitBoxOrient: "vertical",
                    }}
                  >
                    {p.name}
                  </SuiTypography>
                </Tooltip>
              </SuiBox>

              <SuiBox>{formatProjectStatus(p.status)}</SuiBox>
            </SuiBox>

            <SuiBox
              display="flex"
              alignItems="center"
              justifyContent="space-between"
              width="100%"
              pb={0.5}
            >
              <SuiTypography
                variant="body1"
                textTransform="capitalize"
                sx={{ whiteSpace: "nowrap" }}
              >
                Service Provider:
              </SuiTypography>
              {p?.provider?.name ? (
                <SuiBox display="flex" justifyContent="flex-start" alignItems="center" gap={1}>
                  <SuiBox component={Link} to={`/wall/portfolio/${p?.provider_id}`}>
                    <Tooltip position="top" title={p?.provider?.name}>
                      <SuiAvatar
                        src={p?.provider?.metadata?.avatar}
                        alt="profile-image"
                        variant="circle"
                        size="xs"
                        shadow="sm"
                      />
                    </Tooltip>
                  </SuiBox>
                  <SuiBox component={Link} to={`/wall/portfolio/${p?.provider_id}`}>
                    <SuiTypography variant="button" fontWeight="regular" textTransform="capitalize">
                      {p?.provider?.name}
                    </SuiTypography>
                  </SuiBox>
                </SuiBox>
              ) : (
                "N/A"
              )}
            </SuiBox>
            <SuiBox
              key={"budget"}
              display="flex"
              justifyContent="space-between"
              width="100%"
              pb={0.5}
            >
              <SuiTypography variant="body1" textTransform="capitalize">
                Budget:
              </SuiTypography>
              {p?.quote?.budget_min != p?.quote?.budget_max ? (
                <SuiBox display="flex" alignItems="center">
                  <NumberFormat
                    value={p?.quote?.budget_min}
                    displayType={"text"}
                    thousandSeparator={true}
                    prefix={"$"}
                    renderText={(value, props) => (
                      <SuiTypography variant="body1" fontWeight="regular" color="text" {...props}>
                        {value}
                      </SuiTypography>
                    )}
                  />
                  ~{" "}
                  <NumberFormat
                    value={p?.quote?.budget_max}
                    displayType={"text"}
                    thousandSeparator={true}
                    prefix={"$"}
                    renderText={(value, props) => (
                      <SuiTypography variant="body1" fontWeight="regular" color="text" {...props}>
                        {value}
                      </SuiTypography>
                    )}
                  />{" "}
                </SuiBox>
              ) : (
                <NumberFormat
                  value={p?.quote?.budget_min}
                  displayType={"text"}
                  thousandSeparator={true}
                  prefix={"$"}
                  renderText={(value, props) => (
                    <SuiTypography variant="body1" fontWeight="regular" color="text" {...props}>
                      {value}
                    </SuiTypography>
                  )}
                />
              )}
            </SuiBox>
          </SuiBox>
        ))}
      </SuiBox>
    </SuiBox>
  );

  const MessageCell = ({ room, projects = [] }) => (
    <SuiBox className="flex items-center">
      <Badge variant="dot" color="error" invisible={room.ts <= room.viewts}>
        <ContactAvatar room={room} />
      </Badge>
      <div
        className="w-full"
        onClick={() => {
          setSelectedItem({ chatroom: room, project: projects.length > 0 ? projects[0] : {} });
          setChatVisible(true);
        }}
      >
        <div className="flex justify-between items-center">
          <SuiTypography
            variant="body1"
            fontWeight="bold"
            textTransform="capitalize"
            className={`block ml-2 text-gray-600 font-semibold`}
          >
            {room.name}
          </SuiTypography>
          <SuiTypography variant="caption" className={`block ml-2 text-gray-600`}>
            {smartdate.format(new Date(room.ts))}
          </SuiTypography>
        </div>
        <div className="flex justify-between">
          <SuiTypography
            className={`ml-2 text-gray-600`}
            variant="caption"
            textTransform="none"
            color="secondary"
            lineHeight="1.2"
            sx={{
              width: "100%",
              minHeight: "28px",
              overflow: "hidden",
              textOverflow: "ellipsis",
              display: "-webkit-box",
              WebkitLineClamp: "2",
              WebkitBoxOrient: "vertical",
            }}
          >
            {room.lastcontent}
          </SuiTypography>
        </div>
      </div>
    </SuiBox>
  );

  const retrieveChats = async () => {
    try {
      api.chatroom.listChatRoom("project", "", "").then(({ data }) => {
        var chatrooms = new Map();
        for (const room of data.chats) {
          if (chatrooms.has(room.regardingid) && chatrooms.get(room.regardingid).ts > room.ts) {
            continue;
          }
          chatrooms.set(room.regardingid, room);
        }
        setChats(chatrooms);
      });
    } catch (err) {
      console.log(err);
    }
  };

  const ListProjectByStyle = async () => {
    let projects = {};
    for (let i = 0; i < products.length; i++) {
      try {
        const { data } = await api.products.listProjectsByStyle(products[i].id);
        let myProjects = data?.product?.projects || [];

        for (let j = 0; j < myProjects.length; j++) {
          if (myProjects[j].provider_id) {
            const user = await api.account.get(myProjects[j].provider_id);
            const stores = user?.data?.user?.stores || [];
            if (stores.length > 0) {
              myProjects[j]["provider"] = stores[0];
            }
          }
        }

        projects[products[i].id] = myProjects;
      } catch (err) {
        console.log(err);
      }
    }
    setProjectMaps(projects);
  };

  const EmptyCell = ({ name, href }) => (
    <SuiBox component={href ? Link : "div"} to={href} sx={{ width: "100%", height: "100%" }}>
      <SuiBox
        to={href}
        sx={{
          border: "1px dashed",
          borderWidth: ({ borders }) => borders.borderWidth[2],
          borderColor: ({ borders }) => borders.borderColor,
          height: "100%",
          width: "100%",
          borderRadius: 4,
        }}
      >
        {name}
      </SuiBox>
    </SuiBox>
  );

  const CarouselCell = ({ items, href }) => (
    <Carousel
      arrows={true}
      dots={false}
      prevArrow={
        <div>
          <button
            class="react-multiple-carousel__arrow-small react-multiple-carousel__arrow--left-small "
            type="button"
          ></button>
        </div>
      }
      nextArrow={
        <div>
          <button
            class="react-multiple-carousel__arrow-small react-multiple-carousel__arrow--right-small "
            type="button"
          ></button>
        </div>
      }
    >
      {items.map((item, index) => (
        <SuiBox component={href ? Link : "div"} to={href}>
          <ImageCardWrapper data={item} mode={"normal"} height={150} width={150} iconMode />
        </SuiBox>
      ))}
    </Carousel>
  );

  const getStyleTableRow = (item) => {
    const styleMeta = item?.style || {};

    let category = item?.type || "No Category";
    let path = [];
    if (typeof category == "object") {
      category = category?.value;
    } else {
      const categoryNode = findNodeByID(tree, category);
      category = categoryNode?.label || category;
    }

    let designImages = getStyleImages(item, false, ["imageFiles"]);
    let techPackImages = getStyleImages(item, false, ["techPacksFiles"]);
    let sampleImages = getStyleImages(item, false, ["referenceFiles"]);
    //retrive chatroom
    const projects = projectMaps[item.id];
    let room = null;
    if (projects && projects.length > 0) {
      room = chats && chats.has(projects[0].id) ? chats.get(projects[0].id) : null;
    }

    const actions = [
      {
        label: (
          <SuiTypography variant="body" color="error">
            Remove Style
          </SuiTypography>
        ),
        onClick: (e) => {
          e.stopPropagation();
          setSelectedStyle(item);
          setDeleteStyleVisible(true);
        },
        icon: <DeleteForeverRoundedIcon fontSize={"small"} color="error" />,
      },
    ];

    return {
      key: item.id,
      designImages: designImages,
      techPackImages: techPackImages,
      sampleImages: sampleImages,
      name: item.title,
      style_number: styleMeta?.style_number,
      projects: projects || [],
      binding: item.binding,
      message: room,
      detail: {
        title: item.title,
        category: category,
        created_at: item.created_at,
        season: styleMeta?.season,
        year: styleMeta?.year,
        brand: styleMeta?.brand,
        size: styleMeta?.size,
      },
      action: <Actionables actions={actions} />,
    };
  };

  let columns = [
    {
      Header: "Design",
      accessor: "designImages",
      align: "center",
      isSorted: false,
      canSort: false,
      Cell: ({ row, value }) => {
        return (
          <SuiBox width={150} height={150} position="relative">
            {value.length > 0 ? (
              <SuiBox>
                <SuiBox sx={{ position: "absolute", left: 2, bottom: 5 }}>
                  <Tooltip title={row?.original?.style_number}>
                    <SuiBadge
                      variant="gradient"
                      color="secondary"
                      size="sm"
                      badgeContent={
                        <span
                          style={{
                            fontSize: "12px",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            display: "-webkit-box",
                            WebkitLineClamp: "1",
                            WebkitBoxOrient: "vertical",
                          }}
                        >
                          {row?.original?.style_number}
                        </span>
                      }
                    />
                  </Tooltip>
                </SuiBox>
                <CarouselCell
                  items={value}
                  href={
                    sharedView
                      ? `/shared-with-me/styles?id=${row?.original?.key}`
                      : `/workspace/styles-master?id=${row?.original?.key}`
                  }
                />
              </SuiBox>
            ) : (
              <SuiBox sx={{ height: "100%", width: "100%" }}>
                <SuiBox sx={{ position: "absolute", left: 2, bottom: 5 }}>
                  <Tooltip title={row?.original?.style_number}>
                    <SuiBadge
                      variant="gradient"
                      color="secondary"
                      size="sm"
                      badgeContent={
                        <span
                          style={{
                            fontSize: "12px",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            display: "-webkit-box",
                            WebkitLineClamp: "1",
                            WebkitBoxOrient: "vertical",
                          }}
                        >
                          {row?.original?.style_number}
                        </span>
                      }
                    />
                  </Tooltip>
                </SuiBox>
                <EmptyCell
                  name={
                    <SuiBox
                      display="flex"
                      alignItems="center"
                      justifyContent="center"
                      sx={{ height: "100%", width: "100%", px: 1 }}
                    >
                      <AddIcon fontSize="small" />

                      <SuiTypography variant="body2" textTransform="uppercase" fontWeight="bold">
                        Add Design Images
                      </SuiTypography>
                    </SuiBox>
                  }
                  href={
                    sharedView
                      ? `/shared-with-me/styles?id=${row?.original?.key}`
                      : `/workspace/styles-master?id=${row?.original?.key}`
                  }
                />
              </SuiBox>
            )}
          </SuiBox>
        );
      },
    },
    {
      Header: "Tech Pack",
      accessor: "techPackImages",
      align: "center",
      isSorted: false,
      canSort: false,
      Cell: ({ row, value }) => {
        return (
          <SuiBox width={150} height={150}>
            {value.length > 0 ? (
              <CarouselCell
                items={value}
                href={
                  sharedView
                    ? `/shared-with-me/styles?id=${row?.original?.key}&stage=tech-pack`
                    : `/workspace/styles-master?id=${row?.original?.key}&stage=tech-pack`
                }
              />
            ) : (
              <EmptyCell
                name={
                  <SuiBox
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                    sx={{ height: "100%", width: "100%", px: 1 }}
                  >
                    <AddIcon fontSize="small" />

                    <SuiTypography variant="body2" textTransform="uppercase" fontWeight="bold">
                      Add Tech Pack
                    </SuiTypography>
                  </SuiBox>
                }
                href={
                  sharedView
                    ? `/shared-with-me/styles?id=${row?.original?.key}&stage=tech-pack`
                    : `/workspace/styles-master?id=${row?.original?.key}&stage=tech-pack`
                }
              />
            )}
          </SuiBox>
        );
      },
    },
    {
      Header: "Development Project",
      accessor: "projects",
      align: "center",
      isSorted: false,
      canSort: false,
      Cell: ({ row, value }) => {
        if (sharedView) {
          return (
            <SuiBox height={150} minWidth={150}>
              {canWrite && value.length > 0 ? (
                <ProjectCell projects={value} />
              ) : (
                <EmptyCell
                  name={
                    <SuiBox
                      display="flex"
                      alignItems="center"
                      justifyContent="center"
                      sx={{ height: "100%", width: "100%", px: 1 }}
                    >
                      <SuiTypography variant="body2" textTransform="uppercase" fontWeight="bold">
                        N/A
                      </SuiTypography>
                    </SuiBox>
                  }
                />
              )}
            </SuiBox>
          );
        }
        return (
          <SuiBox height={150}>
            {value.length > 0 ? (
              <ProjectCell projects={value} />
            ) : (
              <EmptyCell
                name={
                  <SuiBox
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                    sx={{ height: "100%", width: "100%", px: 1 }}
                  >
                    <AddIcon fontSize="small" />

                    <SuiTypography variant="body2" textTransform="uppercase" fontWeight="bold">
                      Create Project
                    </SuiTypography>
                  </SuiBox>
                }
                href={`/produce/all-projects/create?import_style=${row?.original?.key}`}
              />
            )}
          </SuiBox>
        );
      },
    },

    {
      Header: "Sample",
      accessor: "sampleImages",
      align: "center",
      isSorted: false,
      canSort: false,
      Cell: ({ row, value }) => {
        return (
          <SuiBox width={150} height={150}>
            {value.length > 0 ? (
              <CarouselCell
                items={value}
                href={
                  sharedView
                    ? `/shared-with-me/styles?id=${row?.original?.key}&stage=sample`
                    : `/workspace/styles-master?id=${row?.original?.key}&stage=sample`
                }
              />
            ) : row?.original?.projects?.[0]?.status == "active" ? (
              <EmptyCell
                name={
                  <SuiBox
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                    sx={{ height: "100%", width: "100%", px: 1 }}
                  >
                    <AddIcon fontSize="small" />

                    <SuiTypography variant="body2" textTransform="uppercase" fontWeight="bold">
                      Add Sample
                    </SuiTypography>
                  </SuiBox>
                }
                href={
                  sharedView
                    ? `/shared-with-me/styles?id=${row?.original?.key}&pid={}&stage=sample`
                    : `/workspace/styles-master?id=${row?.original?.key}&stage=sample`
                }
              />
            ) : (
              <SuiBox
                display="flex"
                alignItems="center"
                justifyContent="center"
                sx={{ height: "100%", width: "100%", px: 1 }}
              >
                N/A
              </SuiBox>
            )}
          </SuiBox>
        );
      },
    },
    {
      Header: "Message",
      accessor: "message",
      align: "center",
      isSorted: false,
      canSort: false,
      Cell: ({ row, value }) =>
        value ? (
          <MessageCell room={value} projects={row?.original?.projects} />
        ) : (
          <SuiBox>No Message</SuiBox>
        ),
    },
    {
      accessor: "action",
      isSorted: false,
      canSort: false,
      width: 20,
    },
  ];

  if (sharedView) {
    columns = columns.filter((x) => x.accessor != "message" && x.accessor != "action");
  }

  const rows = filteredStyles.map((item) => getStyleTableRow(item));

  const handleFilterCollections = (str = searchStr) => {
    const copyProducts = products.map((x) => ({ ...x, style_number: x?.style?.style_number }));
    let filteredList = copyProducts;

    if (str) {
      const strUpper = str.toUpperCase();
      const searchFields = ["title", "style_number"];
      filteredList = filteredList.filter((x) => {
        let result = false;
        for (let i = 0; i < searchFields.length; i++) {
          if (x[searchFields[i]]) {
            if (typeof x[searchFields[i]] == "string") {
              if (x[searchFields[i]].toUpperCase().includes(strUpper)) {
                result = true;
              }
            } else if (typeof x[searchFields[i]] == "object") {
              const text = JSON.stringify(x[searchFields[i]]);
              if (text.toUpperCase().includes(strUpper)) {
                result = true;
              }
            }
          }
        }
        return result;
      });
    }

    filteredList = filteredList.sort((a, b) => compare(a, b, orderOpt?.value));
    setFilteredStyles(filteredList);
  };

  const handleSearchChange = (str) => {
    let formattedStr = "";
    if (str) {
      formattedStr = str.trim();
    }
    setSearchStr(formattedStr);
    handleFilterCollections(formattedStr);
  };

  const handleOnSortChange = (e) => {
    setOrderOpt(e);
    let sortStr = e?.value;
    const newFilteredList = filteredStyles.sort((a, b) => compare(a, b, sortStr));
    setFilteredStyles(newFilteredList);
  };

  const handleAfterOk = () => {};

  const canWrite = !sharedView || (sharedView && checkPermission(detail?.id, "", permissionMap));

  const handleEditCollection = async (data) => {
    try {
      setUploading(true);
      const old_meta = detail?.metadata || {};
      //edit collection
      let payload = {
        title: data["collection_name"],
        description: data["description"],
        metadata: {
          ...old_meta,
          year: data["year"],
          season: data["season"],
          brand: data["brand"],
        },
      };

      await api.collections.update(detail.id, payload);
      setUploading(false);

      toast.success(`Your Collection:${data["collection_name"]} has been successfully edited!`);

      handleRefresh();
    } catch (err) {
      console.log(err);
      setUploading(false);
      if (err?.response?.status == 401) {
        return toast.error(err?.response?.data?.error || err?.response?.statusText);
      }
      toast.error(`Your Collection could not be edited!`);
    }
  };

  if (pageLoading) {
    return (
      <div sx={{ p: 3 }}>
        <SuiBox display="flex" alignItems="center" gap={3}>
          <PulseLoader />
          <SuiTypography variant="h6" fontWeight="medium">
            Loading...
          </SuiTypography>
        </SuiBox>
      </div>
    );
  }

  return (
    <div sx={{ p: 3 }}>
      {detail.id ? (
        <SuiBox>
          <Backdrop sx={{ color: "info", zIndex: (theme) => 99999 }} open={uploading}>
            <CircularProgress color="info" sx={{ mr: 1 }} size={32} />
            <SuiTypography variant="h6" fontWeight="medium" color="info">
              Uploading supporting files...
            </SuiTypography>
          </Backdrop>
          <SuiBox mb={2}>
            <NewSharedBar
              type="collection"
              data={detail}
              shareSessionRef={shareSessionRef}
              title={
                <SuiBox
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  sx={{ height: "100%" }}
                >
                  {editNameVisible ? (
                    <div className="flex">
                      <input
                        size="small"
                        defaultValue={detail.title}
                        ref={collectionNameInputRef}
                        onKeyDown={(e) => {
                          if (e.key === "Enter") {
                            handleChangeCollectionName();
                          }
                        }}
                        className="font-serif"
                        autoFocus
                        style={{
                          outline: "none",
                          border: "none",
                          width: inputWidth + "ch",
                          fontSize: "1.25rem",
                          lineHeight: 1.375,
                          fontWeight: 700,
                        }}
                        onChange={(e) => setInputWidth(e.target?.value?.length)}
                        onBlur={handleChangeCollectionName}
                      />
                    </div>
                  ) : (
                    <SuiBox display="flex" alignItems="center" justifyContent="center" gap={1}>
                      <Tooltip title={canWrite ? "Click to change name" : ""}>
                        <SuiTypography
                          variant="h5"
                          className="font-serif"
                          fontWeight="bold"
                          textTransform="none"
                          onClick={() => (canWrite ? handleShowEditCollectionName() : null)}
                        >
                          {detail.title}
                        </SuiTypography>
                      </Tooltip>
                    </SuiBox>
                  )}
                </SuiBox>
              }
            />
          </SuiBox>
          <Card sx={{ mx: 3, py: 2, px: 2 }}>
            <Grid container>
              <Grid item xs={12} sm={7} md={7}>
                <SuiBox px={3}>
                  <form onSubmit={handleSubmit(handleEditCollection)}>
                    <fieldset disabled={!isOwner}>
                      <Grid container spacing={1}>
                        <Grid item xs={12} sm={6}>
                          <SuiBox
                            display="flex"
                            flexDirection="column"
                            justifyContent="flex-end"
                            height="100%"
                          >
                            <SuiBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                              <SuiTypography
                                component="label"
                                variant="caption"
                                fontWeight="bold"
                                required
                                textTransform="capitalize"
                              >
                                Collection Name
                              </SuiTypography>
                            </SuiBox>
                            <SuiInput
                              placeholder="Collection Name"
                              required
                              {...register("collection_name", {
                                required: "A collection name is required!",
                              })}
                            />
                          </SuiBox>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <SuiBox
                            display="flex"
                            flexDirection="column"
                            justifyContent="flex-end"
                            height="100%"
                          >
                            <SuiBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                              <SuiTypography
                                component="label"
                                variant="caption"
                                fontWeight="bold"
                                textTransform="capitalize"
                              >
                                Brand
                              </SuiTypography>
                            </SuiBox>
                            <SuiInput placeholder="Brand" {...register("brand")} />
                          </SuiBox>
                        </Grid>

                        <Grid item xs={12} sm={6}>
                          <SuiBox
                            display="flex"
                            flexDirection="column"
                            justifyContent="flex-end"
                            height="100%"
                          >
                            <SuiBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                              <SuiTypography
                                component="label"
                                variant="caption"
                                fontWeight="bold"
                                textTransform="capitalize"
                              >
                                Year
                              </SuiTypography>
                            </SuiBox>
                            <Controller
                              name="year"
                              control={control}
                              render={({ field }) => {
                                return (
                                  <SuiBox>
                                    <DatePicker
                                      {...field}
                                      picker="year"
                                      placeholder="Year"
                                      style={{ width: "100%" }}
                                      size="large"
                                      popupStyle={{
                                        maxHeight: 400,

                                        overflow: "auto",
                                        zIndex: 9999,
                                      }}
                                    />
                                  </SuiBox>
                                );
                              }}
                            />
                          </SuiBox>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <SuiBox
                            display="flex"
                            flexDirection="column"
                            justifyContent="flex-end"
                            height="100%"
                          >
                            <SuiBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                              <SuiTypography
                                component="label"
                                variant="caption"
                                fontWeight="bold"
                                textTransform="capitalize"
                              >
                                Season
                              </SuiTypography>
                            </SuiBox>
                            <Controller
                              name="season"
                              control={control}
                              render={({ field }) => {
                                return (
                                  <SuiBox>
                                    <SuiSelect
                                      {...field}
                                      options={seasonOptions}
                                      placeholder="Season"
                                      backspaceRemovesValue
                                      isClearable
                                      isCreatable
                                    />{" "}
                                  </SuiBox>
                                );
                              }}
                            />
                          </SuiBox>
                        </Grid>
                        <Grid item xs={12} sm={12}>
                          <SuiBox
                            display="flex"
                            flexDirection="column"
                            justifyContent="flex-end"
                            height="100%"
                          >
                            <SuiBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                              <SuiTypography component="label" variant="caption" fontWeight="bold">
                                Description
                              </SuiTypography>
                            </SuiBox>

                            <SuiInput
                              multiline
                              rows="4"
                              componentsProps={{ input: { maxlength: STYLE_DESC_MAX_LENGTH } }}
                              {...register("description", {
                                maxLength: {
                                  value: STYLE_DESC_MAX_LENGTH,
                                  message: `Maxmium length should not exceed ${STYLE_DESC_MAX_LENGTH} characters`,
                                },
                                value: collectionDesc,
                                onChange: (e) => {
                                  setCollectionDesc(e.target.value);
                                },
                              })}
                              placeholder="Your style description..."
                            />

                            <SuiBox display="flex" justifyContent="space-between">
                              <div>
                                <ErrorMessage
                                  errors={errors}
                                  name="description"
                                  render={({ message }) => (
                                    <SuiTypography
                                      variant="text"
                                      fontWeight="regular"
                                      fontSize="12px"
                                      color="error"
                                      className="ml-2"
                                    >
                                      {message}
                                    </SuiTypography>
                                  )}
                                />
                              </div>
                              <SuiTypography
                                variant="text"
                                color="secondary"
                                fontWeight="regular"
                                fontSize="14px"
                              >
                                {collectionDesc ? collectionDesc.length : 0}/{STYLE_DESC_MAX_LENGTH}
                              </SuiTypography>
                            </SuiBox>
                          </SuiBox>
                        </Grid>
                      </Grid>
                      {!isOwner ? null : (
                        <SuiBox display="flex" justifyContent="flex-end" px={1}>
                          <SuiButton variant="contained" color="dark" type="submit">
                            Save
                          </SuiButton>
                        </SuiBox>
                      )}
                    </fieldset>
                  </form>
                </SuiBox>
              </Grid>
              <Grid item xs={12} sm={5} md={5}>
                <CollectionDetailHeader
                  collection={detail}
                  handleRefresh={handleRefresh}
                  moodboards={moodboards}
                  canWrite={canWrite}
                  sharedView={sharedView}
                />
              </Grid>
            </Grid>

            <SuiBox sx={{ py: 1, minHeight: "100%" }}>
              <SuiBox px={2} display="flex" justifyContent="space-between" alignItems="center">
                <SuiBox>
                  <SuiBox display="flex" alignItems="center" justifyContent="flex-start" gap={2}>
                    {!sharedView ? (
                      <SuiButton
                        variant="gradient"
                        color={"dark"}
                        onClick={() => {
                          setCreateStyleVisible(true);
                        }}
                      >
                        <AddIcon fontSize="sm" sx={{ mr: 0.5 }} />
                        Create Style
                      </SuiButton>
                    ) : null}
                    {!sharedView ? (
                      <SuiButton
                        variant="gradient"
                        color={"dark"}
                        onClick={() => setImportStyleVisible(true)}
                      >
                        <AddPhotoAlternateIcon fontSize="sm" sx={{ mr: 0.5 }} />
                        Import Style
                      </SuiButton>
                    ) : null}
                  </SuiBox>
                </SuiBox>
                <SuiBox display="flex" alignItems="center" justifyContent="flex-end" gap={1}>
                  <SuiBox>
                    <Card sx={{ borderRadius: 2, width: 200, boxShadow: "none" }}>
                      <SuiSelect
                        options={stylesSortOptions}
                        placeholder="Sort"
                        isClearable
                        onChange={handleOnSortChange}
                        value={orderOpt}
                      />
                    </Card>
                  </SuiBox>
                  <SuiBox sx={{ maxWidth: 200 }}>
                    <SuiInput
                      placeholder="Search Keywords"
                      type="text"
                      onChange={(e) => handleSearchChange(e?.target?.value)}
                      icon={{
                        direction: "right",
                        component: (
                          <SearchIcon
                            sx={{ cursor: "pointer" }}
                            onClick={() => handleSearchChange(searchStr)}
                          />
                        ),
                      }}
                    />
                  </SuiBox>
                </SuiBox>
              </SuiBox>

              <SuiBox sx={{ minHeight: 200, overflow: "auto" }}>
                {rows.length > 0 ? (
                  <DataTable
                    table={{ columns, rows: rows }}
                    entriesPerPage={{ defaultValue: 10, entries: [5, 10, 20, 50] }}
                    showTotalEntries={true}
                    pagination={true}
                    noEndBorder
                    sx={{ mt: 0, py: 0 }}
                    isSorted={false}
                  />
                ) : sharedView ? (
                  <EmptyStyleRecord
                    content={
                      <SuiBox
                        display="flex"
                        alignItems="center"
                        justifyContent="center"
                        sx={{ height: "100%", width: "100%" }}
                      >
                        No styles available
                      </SuiBox>
                    }
                  />
                ) : (
                  <EmptyStyleRecord
                    collection={detail}
                    allowImport
                    allowCreate={false}
                    refresh={handleRefresh}
                    handleAfterOk={handleAfterOk}
                  />
                )}
              </SuiBox>

              {selectedStyle && deleteStyleVisible ? (
                <Prompt
                  heading="Remove Style"
                  text={`Are you sure you want to remove ${selectedStyle.title} from your Collection?`}
                  visible={deleteStyleVisible}
                  okText="Remove"
                  okColor="error"
                  handleOk={() =>
                    api.products
                      .update(selectedStyle.id, { collection_id: null })
                      .then(() => {
                        toast.success(`${selectedStyle.title} has been removed successfully!`);
                        handleRefresh();
                        setDeleteStyleVisible(false);
                      })
                      .catch((err) => {
                        console.log(err);
                        toast.error(`Your Style could not be removed!`);
                      })
                  }
                  handleClose={() => setDeleteStyleVisible(false)}
                />
              ) : null}

              {chatVisible ? (
                <DraggableDialog
                  heading="Chat with manufacturer"
                  text={
                    <SuiBox>
                      <ChatRoom
                        id={selectedItem?.chatroom?.id}
                        regardingid={selectedItem?.project?.id}
                      />
                    </SuiBox>
                  }
                  visible={chatVisible}
                  hideAction={true}
                  handleClose={() => {
                    setChatVisible(false);
                    retrieveChats();
                  }}
                />
              ) : null}

              {projectDetailVisible ? (
                <ProjectDetailSimpleModal
                  visible={projectDetailVisible}
                  handleClose={() => setProjectDetailVisible(false)}
                  project={projectDetail}
                />
              ) : null}

              {importStyleVisible ? (
                <ImportStyleModal2
                  handleClose={() => setImportStyleVisible(false)}
                  visible={importStyleVisible}
                  isEdit={false}
                  categoryTree={tree}
                  collection={detail}
                  handleRefresh={() => {
                    handleRefresh();
                  }}
                />
              ) : null}
              {createStyleVisible ? (
                <FullCreateStyleModal
                  handleClose={() => setCreateStyleVisible(false)}
                  visible={createStyleVisible}
                  isEdit={false}
                  categoryTree={tree}
                  handleRefresh={handleRefresh}
                  collectionId={detail.id}
                />
              ) : null}
              {editCollectionVisible && detail?.id ? (
                <CreateCollectionModal
                  handleClose={() => {
                    setEditCollectionVisible(false);
                  }}
                  visible={editCollectionVisible}
                  isEdit={true}
                  collection={detail}
                  handleRefresh={handleRefresh}
                />
              ) : null}
            </SuiBox>
          </Card>
        </SuiBox>
      ) : null}
    </div>
  );
};

export default CollectionDetail;
